import { mkIdentity } from './identitiesTypes';

export function transformIdentityToRequestData(identity) {
  return {
    id: identity.id,
    clientId: identity.clientId,
    firstName: identity.firstName,
    middleName: identity.middleName,
    lastName: identity.lastName,
    suffix: identity.suffix,
    dateOfBirth: identity.dateOfBirth,
    // ssn: identity.ssn, // this should always be encrypted when sent
    ssnEncrypted: identity.ssnEncrypted,
    addressId: identity.addressId,
    userProfileId: identity.userProfileId,
    emailId: identity.emailId,
    phoneId: identity.phoneId,
    primary: identity.primary,
  };
}

export function transformIdentityResponseWithResource(resource, response) {
  if (response?.data?.resource) {
    return resource?.merge
      ? resource.merge(response.data.resource)
      : mkIdentity({ ...resource, ...response.data.resource });
  }
  return resource;
}
